import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container"]
  static values = {
    type: String,
    message: String,
    duration: { type: Number, default: 300 }
  }

  connect() {
    this.show()
    this.autoDismiss()
  }

  show() {
    this.containerTarget.classList.remove('translate-x-full');
    this.containerTarget.classList.add('translate-x-0');
  }

  close() {
    this.containerTarget.classList.remove('translate-x-0');
    this.containerTarget.classList.add('translate-x-full');
    setTimeout(() => {
      this.element.remove();
    }, 300);
  }

  autoDismiss() {
    setTimeout(() => {
      this.close()
    }, this.durationValue)
  }
}